export enum StorageKeysEnum {
  system = "system",
  authTokens = "authTokens",
}
